module.exports = __webpack_public_path__ + "img/doctor.e2981e81.png";